import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icons/tick-green.png'
import _imports_1 from '../../assets/icons/close-red.png'


const _withScopeId = n => (_pushScopeId("data-v-bd042410"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  src: _imports_0,
  alt: "ikon"
}
const _hoisted_2 = {
  key: 1,
  src: _imports_1,
  alt: "ikon"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'statusBar',
  props: ["backgroundColor", "icon"],
  setup(__props) {



const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "status-bar-container",
    style: _normalizeStyle({backgroundColor: props.backgroundColor, borderColor: props.backgroundColor})
  }, [
    (props.icon === 'tick')
      ? (_openBlock(), _createElementBlock("img", _hoisted_1))
      : _createCommentVNode("", true),
    (props.icon === 'x')
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}
}

})